// generated file, if you want to edit this file manually change the word "generated" to "manual"

import MaterialFormControl from '@mui/material/FormControl';
import { isVariantEnabled, makeThemedStyles } from '@qpr/components/utils';
import clsx from 'clsx';
import React from 'react';

const useStylesForFormControl = makeThemedStyles('FormControl', () => ({
  FormControl: {
    margin: '0px',
    padding: '0px',
    display: 'flex'
  },

  inline: {
    display: 'inline-flex'
  }
}));

type PropType = React.ComponentProps<typeof MaterialFormControl>;

export const FormControl: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForFormControl();

  // Pick classes from the theme if they are defined
  // const theme = useTheme();
  // const themeObj = (theme as any)?.qpr?.FormControl
  const enabledClasses: { [key: string]: string } = {};
  const variants = ['FormControl', 'SelectLarge', 'Select', 'HelperText', 'inline'];
  Object.keys(styles || {})
    .filter(key => !variants.includes(key))
    .forEach(key => {
      if ((styles as any)[key]) {
        enabledClasses[key] = (styles as any)[key];
      }
    });

  /* eslint-disable */
  return (
    <MaterialFormControl
      {...props}
      classes={{
        root: styles.FormControl,
        ...enabledClasses
      }}
      className={clsx(styles.FormControl, {
        [styles.inline]: isVariantEnabled(props, 'inline')
      })}
    >
      {props?.children}
    </MaterialFormControl>
  );
};
export default FormControl;
